import React, { useState } from 'react';
import { AddShowingRequest, ShowingDetails } from '../models/api';
import Button from './Button';
import DateTimePicker from './DateTimePicker';
import Feedback from './Feedback';

type ShowingsFormProps = {
  model: ShowingDetails | null | undefined;
  submit: (e: AddShowingRequest) => Promise<boolean>;
  isSubmitting: boolean;
  errors: string[];
  close: () => void;
  buttonText: string;
};

const ShowingsForm: React.FC<ShowingsFormProps> = ({
  model,
  submit,
  isSubmitting,
  errors,
  close,
  buttonText
}) => {
  let initialDate: Date | null = null;
  if (model?.startDateUtc) {
    let initialDateString = model.startDateUtc;
    if (!initialDateString.endsWith('Z')) {
      initialDateString = initialDateString + 'Z';
    }
    initialDate = new Date(initialDateString);
  } else {
    const now = new Date();
    initialDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      now.getHours()
    );
  }

  const [startDateUtc, setStartDateUtc] = useState<Date | null>(initialDate);
  const [location, setLocation] = useState(model?.location ?? '');

  const handle = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const result = await submit({
      startDateUtc: startDateUtc?.toISOString() ?? '',
      location
    });

    if (result) {
      setStartDateUtc(initialDate);
      setLocation('');
    }
  };

  return (
    <form onSubmit={handle} className="content-form">
      <DateTimePicker
        initialDate={startDateUtc}
        dateTitle="Start"
        onDateChange={(e) => setStartDateUtc(e)}
        disabled={!!model?.presentationStartUtc}
      />
      {!!model?.presentationStartUtc && !model?.endDateUtc && (
        <span>
          Start date cannot be edited for showings that are being presented
        </span>
      )}
      {!!model?.endDateUtc && (
        <span>
          Start date cannot be edited for showings that have been ended
        </span>
      )}
      <div className="field">
        <label htmlFor="location">Location</label>
        <input
          id="location"
          type="text"
          placeholder="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
      </div>
      <div className="button-container">
        <Button isLoading={isSubmitting} isSubmit={true}>
          {buttonText}
        </Button>
        <Button type="Outline" onClick={() => close()}>
          Cancel
        </Button>
      </div>
      <Feedback messages={errors} type="error" />
    </form>
  );
};

export default ShowingsForm;
